const PERMISSIONS = {
    ADMIN_SUPERUSER: "admin:superuser",
    CAN_USE_WEBAPP: "usage:webapp",
    CAN_USE_MOBILE: "usage:mobileapp",
}

export default PERMISSIONS